<template>
  <div class="container-fluid footer">
         <div class="row justify-content-center text-center">
             <div class="col-12 col-lg-12 col-xs-12">
                 <strong><p style="margin-top:6%; font-size:1.5em;">Thoughts? Connect with us.</p></strong>
             </div>
         </div>
         <div class="row justify-content-center text-center center-lg">
             <div class="col-lg-5 col-xs-12">
                 <div class="container-fluid text-center">
                     <div class="row justify-content-center">
                         <div class="col-3 col-lg-2 col-xs-3 text-center">
                             <a href="https://www.facebook.com/workteen/" target="_blank" class="btn btn-info social-button"><icon name="facebook-square" scale="2"></icon></a>
                         </div>
                         <div class="col-3 col-lg-2 col-xs-3 text-center">
                             <a href="https://twitter.com/teen_work?lang=en" target="_blank" class="btn btn-info social-button"><icon name="twitter-square" scale="2"></icon></a>
                         </div>
                         <div class="col-3 col-lg-2 col-xs-3 text-center">
                             <a href="mailto:opportunities.workteen@outlook.com" target="_blank" class="btn btn-info social-button"><icon name="envelope" scale="2"></icon></a>
                         </div>
                         <div class="col-3 col-lg-2 col-xs-3 text-center">
                             <a href="http://www.workteen.org" target="_blank" class="btn btn-info social-button"><icon name="home" scale="2"></icon></a>
                         </div>
                     </div>
                 </div>
             </div>
         </div>
         <div class="row justify-content-center text-center">
             <div class="col-12 col-lg-12 col-xs-12">
                 <strong><p style="margin-top:3%; font-size:1.2em;">Made with <icon name="heart" style="margin-top:-5px; color:red;" scale="1"></icon> by the WorkTeen Team.</p></strong>
             </div>
         </div>

     </div>
</template>
<script>

import Vue from 'vue'
import VueMaterial from 'vue-material'
import 'vue-awesome/icons'
import Icon from 'vue-awesome/components/Icon'
// import VuePaginator from 'vuejs-paginator'
import 'vue-material/dist/vue-material.css'
Vue.use(VueMaterial)

// console.log(Vue.$children)
export default {
  name: 'Footer',
  components: {
    Icon
   },
  //defines empty thing really important

};
</script>


<style scoped>
.footer{
  color:black;
  background-color: #f7faff;
  height: auto;
  position: absolute;
  width:100%;
  margin-top:10%;
  border-top:0.5px solid  #05668d;
  text-align:center;
}
p{
  text-align: center;
}
.footer .social-button {
    font-size: 24px;
    /*width: 50px;*/
    /*border:0.5px solid black;*/
    color:#05668d;
    height: 50px;
}
.fa-icon{
  margin:0px;
}
.fa-icon:hover{
  color:#427AA1;
}

.col-lg-2{
  margin-left:6%;
}
@media screen and (max-width: 767px) {
.col-xs-3{
  margin:0px;
}
}

@media screen and (max-width: 479px) {
     /* start of phone styles */

}

</style>


// WEBPACK FOOTER //
// Footer.vue?7057858d